export default class LocationStorageProvider {
  /**
   * @param {*} store Key-value store. Uses localStorage by default.
   */
  constructor(store) {
    this.store = store || window.localStorage;
  }

  /**
   * Serializes bookmarks into a JSON string and saves them to storage.
   * @param {number} bookId
   * @param {string} cfi
   */
  storeLocation(bookId, cfi) {
    this.store.setItem(
      this._storageKey(bookId),
      JSON.stringify(this._generateLocatorRecord(bookId, cfi)),
    );
  }

  /**
   * Retrieves and parses bookmark JSON from storage.
   * @param {number} bookId
   * @returns {string} CFI
   */
  loadLocation(bookId) {
    try {
      const data = JSON.parse(this.store.getItem(this._storageKey(bookId)));
      return data;
    } catch {
      return null;
    }
  }

  _generateLocatorRecord(bookId, newCfi) {
    return {
      bookshareId: bookId,
      location: newCfi,
      dateModified: new Date(),
    };
  }

  _storageKey(bookId) {
    return `cfi-${bookId}`;
  }
}
